import { isEmpty } from 'lodash';

const getAreaResponse = (response) => {
  if (isEmpty(response?.data?.areas)) return [];

  return response?.data?.areas.map((area) => {
    return {
      id: area?.id,
      value: area?.id?.toString() || '',
      label: area?.name,
    };
  });
};

export default getAreaResponse;
